
import { Portal } from 'portal-vue'
import { Component, Prop, Vue, Watch } from 'vue-property-decorator'

import { TixTimeDuration } from '@/TixTime/Duration'
import { LanguageStrings } from '@/language/types'

@Component({ name: 'ExpiryTimer', components: { Portal } })
export default class extends Vue {
  t: LanguageStrings['expiryTimer']

  @Prop()
  expiresIn: TixTimeDuration

  // For screen readers only
  screenReaderExpiryMinutes: number | null = null
  screenReaderExpirySeconds: number | null = null

  // Threshold in seconds
  readonly thresholdWarning = 5 * 60
  readonly thresholdError = 2 * 60
  readonly thresholdCritical = 30

  mounted() {
    this.updateScreenReaderExpiry()
  }

  updateScreenReaderExpiry() {
    this.screenReaderExpiryMinutes = this.expiresIn.minutes()
    this.screenReaderExpirySeconds = this.expiresIn.seconds()
  }

  @Watch('expiresIn')
  handleExpiresInChange() {
    const thresholds = [this.thresholdWarning, this.thresholdError]
    if (this.flags.extend_cart_timer) {
      thresholds.push(this.thresholdCritical)
    }

    if (thresholds.includes(Math.round(this.expiresIn.asSeconds()))) {
      this.updateScreenReaderExpiry()
    }
  }

  get formattedTime() {
    const expiresIn = this.expiresIn
    if (expiresIn.asSeconds() > 0) {
      return expiresIn.format('m:ss')
    } else {
      return null
    }
  }

  get timerStatus(): 'info' | 'warning' | 'error' {
    const timeRemaining = this.expiresIn.asSeconds()
    if (timeRemaining > this.thresholdWarning) {
      return 'info'
    } else if (timeRemaining > this.thresholdError) {
      return 'warning'
    } else {
      return 'error'
    }
  }

  get screenReaderTimer() {
    return this.$t('expiryTimer.screenReaderExpiresIn', {
      minutes: this.screenReaderExpiryMinutes,
      seconds: this.screenReaderExpirySeconds,
    })
  }
}
